module.exports = __webpack_public_path__ + "img/icon_card_suspend.ec5b4827.png";